import { fmtYMD } from "./dateFormat";

/** Devuelve el índice del día de la semana con Lunes = 0, Domingo = 6 */
export function weekdayMon0(date) {
  return (date.getDay() + 6) % 7;
}

/** Suma n días a una fecha y devuelve una nueva Date */
export function addDays(d, n) {
  const x = new Date(d);
  x.setDate(x.getDate() + n);
  return x;
}

export function startOfWeekMonday(date) {
  const day = date.getDay();
  const diff = day === 0 ? -6 : 1 - day;
  return addDays(date, diff);
}

export function endOfWeekMonday(date) {
  return addDays(startOfWeekMonday(date), 6);
}

/**
 * Genera la grilla de días para un mes dado (incluyendo días prev/next para
 * completar las filas de Lunes a Domingo).
 *
 * Devuelve un array de objetos:
 * { date: Date, label: string, type: "current" | "prev" | "next", ymd: string }
 */
export function getCalendarGrid(monthCursor) {
  const y = monthCursor.getFullYear();
  const m = monthCursor.getMonth();

  const first = new Date(y, m, 1);
  const last  = new Date(y, m + 1, 0);

  const gridStart = addDays(first, -weekdayMon0(first));
  const gridEnd   = addDays(last,  6 - weekdayMon0(last));

  const msDay    = 24 * 60 * 60 * 1000;
  const totalDays = Math.round((gridEnd - gridStart) / msDay) + 1;

  const days = [];
  for (let i = 0; i < totalDays; i++) {
    const date = addDays(gridStart, i);
    const isCurrent = date.getFullYear() === y && date.getMonth() === m;
    days.push({
      date,
      label: String(date.getDate()),
      type:  isCurrent ? "current" : date < first ? "prev" : "next",
      ymd:   fmtYMD(date),
    });
  }

  return days;
}